import { create } from 'zustand';

import { TDrawerOptions, TPollView } from '@src/types';

interface IDrawerStore {
  selectedKey: TDrawerOptions;
  activePollView: TPollView;
  setActivePollView: (mode: TPollView) => void;
  isDrawerOpen: boolean;
  setSelectedKey: (key: TDrawerOptions, value?: boolean) => void;
  toggleDrawer: (open: boolean) => void;
}

export const useDrawerStore = create<IDrawerStore>((set, get) => ({
  selectedKey: 'chat',
  isDrawerOpen: false,
  activePollView: 'create',
  setActivePollView: (mode: TPollView) => {
    set({ activePollView: mode });
  },
  setSelectedKey: (key: TDrawerOptions, value?: boolean) => {
    const { selectedKey, isDrawerOpen } = get();

    set({
      selectedKey: key,
      isDrawerOpen: value ?? (selectedKey === key ? !isDrawerOpen : true), // Toggle drawer
    });
  },
  toggleDrawer: (open: boolean) =>
    set(() => ({
      isDrawerOpen: open,
    })),
}));
